<template>
	<div class="d-flex justify-content-between">
		<label
			:for="props.membershipType.waitListItemId"
			class="caption"
			:aria-describedby="`${props.membershipType.waitListItemId}-description`"
		>
			{{ props.membershipType.title }}
		</label>
		<button
			v-if="!membershipType.openpanel"
			class="px-2 btn-reset btn-chevron"
			type="button"
			:aria-expanded="open"
			:aria-controls="`${props.membershipType.waitListItemId}-description`"
			@click="() => (open = !open)"
		>
			<ChevronUpIcon v-if="open" :height="12" :width="12" />
			<ChevronDownIcon v-else :height="12" :width="12" />
			<span class="visually-hidden">Show / Hide {{ props.membershipType.title }} description</span>
		</button>
	</div>
	<BCollapse :id="`${props.membershipType.waitListItemId}-description`" v-model="open">
		<p v-if="startingPrice && membershipType.waitListItemId === 'signature'" class="mt-3">
			Starting at {{ props.startingPrice }}/mo
		</p>
		<!-- eslint-disable-next-line vue/no-v-html -->
		<div class="membership-description mt-3" v-html="props.membershipType.description"></div>
	</BCollapse>
</template>

<script lang="ts" setup>
import { onBeforeMount, ref } from 'vue';
import { BCollapse } from 'bootstrap-vue-next';
import ChevronDownIcon from 'Lib/icons/ChevronDownIcon.vue';
import ChevronUpIcon from 'Lib/icons/ChevronUpIcon.vue';
import type { AemuiWaitlistItem } from 'Types/aemui/content-fragments/contentFragment';

const props = defineProps<{
	membershipType: AemuiWaitlistItem;
	startingPrice: string | null;
}>();

const open = ref(false);

onBeforeMount(() => {
	open.value = props.membershipType.openpanel;
});
</script>

<style lang="scss" scoped>
.btn-reset {
	background-color: transparent;
	border: 0;
}
</style>
